import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceField,
  TextField,
} from "react-admin";
import exporter from "./exporter";
import { Stack, Typography } from "@mui/material";
import { useAuth } from "../../../hooks/useAuth";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import makeFilters from "./Filter";
import { requestTypeAdminLabels } from "../../../lib/constants";
import { UnfinishedSigningsAlert } from "../UnsignedContractRequest";
import { useBulkActionButtons } from "../deleteControls";

function ContractRequestTable(props) {
  const title = props.disableAppbarTitle ? " " : null;
  const { user, isFullAdmin } = useAuth();
  const bulkActionButtons = useBulkActionButtons();

  return (
    <List
      {...props}
      perPage={25}
      title={title}
      filters={makeFilters(user.role)}
      exporter={exporter}
    >
      <>
        <Typography p={2} variant="h6">
          {props.title}
        </Typography>
        <Datagrid rowClick="edit" bulkActionButtons={bulkActionButtons}>
          <DateField locale="en-US" options="short" source="createdAt" />
          <FunctionField
            label="Request Type"
            source="requestType"
            render={(record) => requestTypeAdminLabels[record.requestType]}
          />
          <TextField source="npn" label="NPN" />
          <BooleanField
            width={60}
            source="unknownAgent"
            label="Unknown Agent"
            FalseIcon={null}
            TrueIcon={WarningAmberIcon}
          />
          {/* #96 - every role sees the agency: a principal with a downline has
              requests from several agencies in this list. PURL stays staff-only. */}
          <ReferenceField label="Agency" source="agency" reference="agency" emptyText="—">
            <TextField source="name" />
          </ReferenceField>
          {isFullAdmin(user) && (
            <ReferenceField label="PURL" source="agency" reference="agency">
              <TextField source="domain" />
            </ReferenceField>
          )}
          {/* #21 — read-only: the routed ACE name (always set). */}
          <TextField source="specialistName" label="ACE" emptyText="—" />
          {/* #57 - white glove: who prepared the request, when a principal did. */}
          <TextField source="preparedByName" label="Prepared by" emptyText="—" />
          <TextField source="phone" />
          <TextField source="firstName" />
          <TextField source="lastName" />
        </Datagrid>
      </>
    </List>
  );
}

export const ContractList = () => (
  <Stack direction="column">
    {/* #12 — drop-off warning for Applied GA admins (self-gates). */}
    <UnfinishedSigningsAlert />
    <ContractRequestTable />
  </Stack>
);

export default ContractList;
